import { COMMON, offerPurchaseMethods } from "root/libs/constants/src";

const EXCLUDED_OFFER_KEYS = new Set([
  COMMON.TARGET_SERVICE_CARD_KEY,
  COMMON.DOMESTIC_TRANSPORT_SOLUTION_CARD_KEY,
]);

export const applyDefaultPurchaseMethod = (offers) =>
  offers.map((offer) => {
    if (
      offer.purchaseMethod !== undefined ||
      EXCLUDED_OFFER_KEYS.has(offer.key)
    ) {
      return offer;
    }

    return { ...offer, purchaseMethod: offerPurchaseMethods.CLICK };
  });
